module.exports = __webpack_public_path__ + "img/11.03066dd3.png";